import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import constants from "../../../config/constants.json"
import { useNavigate } from "react-router-dom";
import { authService, getUserSelectedRole } from "../../../infrastructure/backendService";
import { isNil } from "lodash";
import { RoutingURLs, SubRoutingURLs } from "../../common/RoutingURLs";
import styles from '../../../components/common/common.module.scss';

interface successComponentProps {
  headerMessage?: string;
  showMessage?: string;
  extraMessage?: string;
  isOpen: boolean;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onCreditClick?: () => void;
  // showCloseButton?: boolean;
  isNavigate?:boolean;
  warningMessage?: string;
}

const SuccessPopup = (props: successComponentProps) => {

  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );


  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
      if(!isNil(props.isNavigate)) {
        if(props.isNavigate) {
          if (hasManagerLevelRole) {
            navigate(
              `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
            );
          } else if(!authService.isAuthenticated()) {
            navigate("/");
          } else {
            navigate(RoutingURLs.dashboard);
          }
        }
      }
      
    }, constants.TOAST_POPUP_DURATION);

    return () => clearTimeout(timer);
  }, [isOpen]);

  const handleClose = (): void => {

    setIsOpen(false);
    props?.setIsOpen?.(false);
    toast.remove();
    };

    

  return (
    <>
      <div>
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              margin: "32px",
              borderRadius: "16px",
              background: "#FFF",
              maxHeight: "auto",
              maxWidth: "800px",
              width: "700px",
              flexDirection: "column",
            },
          }}
        >
          <div className={styles.SuccessMessageContainer}>
            <DialogTitle className={styles.SuccessMessageTitle}>
              {props.headerMessage}
            </DialogTitle>
            <IconButton
            id="closeButton"
              aria-label="close"
              onClick={handleClose}
              sx={{
                float: "right",
                color: "#fff",
                padding: "10px",
                marginLeft: "auto",
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <DialogContent className={styles.SuccessMessageDiagloContent}>
            <img src="/images/successImage.svg" />
            <Typography className={styles.SuccessMessageContent}>
              {props.showMessage}
            </Typography>
            <div
              style={{
                textAlign: "center",
                textDecoration: "underline",
                fontFamily: "Lato",
                color: "#f05802",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              <div onClick={props?.onCreditClick}>{props?.extraMessage}</div>
            </div>
            {props?.warningMessage && <Box mt="15px">
              <Typography sx={{fontFamily: "Lato", fontSize: "17px", textAlign: "start !important", color: "red"}}>Note: {props?.warningMessage}</Typography>
              </Box>}
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default SuccessPopup;
